import { useAuth0 } from '@auth0/auth0-react';

import { useJoinAuth } from '~/components/JoinAuthProvider';
import { Button } from '~/components/scales';
import { SIGN_UP } from '~/constants';

export default function LoginPage() {
  const { loginWithRedirect, loginWithPopup } = useAuth0();
  const auth = useJoinAuth();

  const isIFramed = window.self !== window.top;

  // Login flow for app embedded in non join domains
  if (!auth.isAuthenticated && !auth.loggedIn && isIFramed) {
    return (
      <div className="bg-white-000 flex h-screen w-screen flex-col items-center justify-center space-y-4">
        <h3 className="type-heading2">You are trying to access Join</h3>
        <Button
          data-cy="login-popup-button"
          label="Log in to Join "
          onClick={() => loginWithPopup()}
          type="primary"
        />
      </div>
    );
  }

  // Normal login flow using redirect
  if (!auth.isAuthenticated && !auth.loggedIn) {
    const { search } = window.location;
    // Navigate to the signup page if the user does not have an auth0 account
    if (search.toLowerCase().includes(SIGN_UP)) {
      loginWithRedirect({ screen_hint: SIGN_UP });
    } else {
      loginWithRedirect();
    }
    // Assuming that the user will sign in
    localStorage.setItem(`user_session_start_at`, new Date().toISOString());
  }
  return <div className="bg-white-000 h-screen w-screen" />;
}
